import * as getters from '@/store/modules/transfers/periodic/getters'
import * as mutations from '@/store/modules/transfers/periodic/mutations'
import * as actions from '@/store/modules/transfers/periodic/actions'

const state = {
    accountsBalances: [],
    recurringTransfers: [],
    scheduleTypes: [],
    lastRecurringTransfersInfo: {},
    recurringTransfersHasMore: false,
    beneficiaryName: null
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
